import {settings} from './settings';

export const apiURL = process.env.REACT_APP_API_URL ?? ''
export const waitTimeForStatus = settings.env.REACT_APP_WAIT_TIME_FOR_STATUS_SECONDS
